import { parseCurrency } from '@helper/parseCurrency'

import {
  getStatus,
  removeDecimalPlaces,
  toLocaleString,
  toLocaleString2,
  toLocaleString3
} from '../strings'

export const parseDistributionMrpData = (data: any[]): any[] => {
  const res = []

  data = JSON.parse(JSON.stringify(data))

  for (const item of data) {
    res.push({
      'centro-id': item.estoque.loja.id,
      'centro-nome': item.estoque.loja.descricao,

      'centro-distribuicao-id': item.estoque.centroDistribuicao
        ? item.estoque.centroDistribuicao.id
        : '',
      'centro-distribuicao-nome': item.estoque.centroDistribuicao
        ? item.estoque.centroDistribuicao.descricao
        : '',

      'produto-id': item.estoque.produtoFornecedor.produto.id,
      'produto-categoria-compacta':
        item.estoque.categoriaCompactaDescricao.toUpperCase(),
      'produto-sub-categoria':
        item.estoque?.subCategoriaDescricao?.toUpperCase(),
      'produto-mundo': item.estoque.mundoDescricao.toUpperCase(),

      'produto-material': item.estoque.produtoFornecedor.produto.descricao,
      'produto-categoria':
        item.estoque.produtoFornecedor.produto.categoria.descricao,
      'produto-curva-abc': item.estoque.curvaABC,
      'produto-curva-abc-empresa': item.estoque.curvaABCEmpresa,
      'produto-status': item.estoque.textoStatus,
      'produto-lote': toLocaleString3(
        item.estoque.produtoFornecedor.quantidadePacote
      ),
      'produto-grupo-separacao':
        item.estoque.produtoFornecedor.produto.grupoCarga.descricao,

      'fornecedor-id': item.estoque.produtoFornecedor.fornecedor
        ? item.estoque.produtoFornecedor.fornecedor.id
        : '',
      'fornecedor-nome': item.estoque.produtoFornecedor.fornecedor
        ? item.estoque.produtoFornecedor.fornecedor.descricao
        : '',

      'recomendacao-quantidade': toLocaleString2(
        item.valorRecomendacao ? item.valorRecomendacao.quantidade : 0
      ),
      'recomendacao-peso': toLocaleString(
        item.valorRecomendacao ? item.valorRecomendacao.peso : 0
      ),
      'recomendacao-volume': toLocaleString(
        item.valorRecomendacao ? item.valorRecomendacao.volume : 0
      ),
      'recomendacao-custo': toLocaleString(
        item.valorRecomendacaoCustoFinal ? item.valorRecomendacaoCustoFinal : 0
      ),
      'recomendacao-tipo-alerta': getStatus(item.motivoRecomendacao),

      'recomendacao-nivel-servico': (item.valorRecomendacao
        ? item.valorRecomendacao.nivelServico * 100
        : 0
      ).toLocaleString('pt-BR', {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1
      }),

      'compra-peso': toLocaleString(item.desejada.peso),
      'compra-volume': toLocaleString(item.desejada.volume),
      'compra-desejada':
        (item.ajustadoPeloFaturamentoMinimo === true ? 'T' : 'F') +
        (item.desejada
          ? parseCurrency({
              value: item.desejada.quantidade,
              country: 'pt-br',
              minFraction: 0,
              maxFraction: 0
            })
          : 0),
      'compra-custo': toLocaleString(item.desejadaCustoFinal),
      'compra-nivel-servico': (item.desejada.nivelServico * 100).toLocaleString(
        'pt-BR',
        {
          minimumFractionDigits: 1,
          maximumFractionDigits: 1
        }
      ),

      'estoque-max': toLocaleString2(item.estoque.maximo),
      'estoque-cd': toLocaleString2(item.estoque.disponivelCentroDistribuicao),
      'estoque-reservado': toLocaleString2(item.estoque.quantidadeReservada),
      'estoque-disponivel': toLocaleString2(item.estoque.disponivel),
      'estoque-transito': toLocaleString2(item.estoque.ordenadoTotal),
      'estoque-dep': toLocaleString2(
        item.estoque.estoquesIndisponiveis.Deposito16
      ),
      'estoque-outros': toLocaleString2(
        item.estoque.estoquesIndisponiveis.Luizinho
      ),
      'estoque-venda-diaria': toLocaleString(
        item.previsaoDemanda ? item.previsaoDemanda.vendasMediasDiarias : 0
      ),
      'estoque-venda-mensal': toLocaleString(
        item.previsaoDemanda ? item.previsaoDemanda.vendasMediasDiarias * 30 : 0
      ),
      'estoque-qtde-ponto-pedido': toLocaleString(
        item.estoque.pontoPedido ? item.estoque.pontoPedido : 0
      ),

      'cobertura-alvo': toLocaleString2(item.coberturaAlvo),
      'cobertura-atual': toLocaleString2(
        item.previsaoDemanda ? item.previsaoDemanda.coberturaDisponivel : 0
      ),
      'cobertura-transito': toLocaleString2(
        item.previsaoDemanda.disponivelMaisCoberturaOrdenada -
          item.previsaoDemanda.coberturaDisponivel
      ),
      'cobertura-ponto-pedido': parseCurrency({
        value: item.estoque.pontoPedidoDias ? item.estoque.pontoPedidoDias : 0,
        country: 'pt-br',
        minFraction: 0,
        maxFraction: 0
      }),
      'cobertura-sugestao': toLocaleString2(
        item.valorRecomendacao ? item.valorRecomendacao.cobertura : 0
      ),
      'cobertura-desejada': item.desejada
        ? toLocaleString2(item.coberturaDesejada)
        : 0,
      'cobertura-diferenca': toLocaleString2(item.diferenca),
      'estoque-id': item.estoque?.id,
      'gerente-produto-id': toLocaleString2(item.estoque.gerenteProdutoId),
      'gerente-produto-desc': toLocaleString2(
        item.estoque.gerenteProdutoDescricao
      ),
      'cobertura-formatada': item.resultadoFormacaoCarga
        ? removeDecimalPlaces(item.resultadoFormacaoCarga.coberturaFinal)
        : 0,
      'carga-desejada': '',
      'carga-quantidade': toLocaleString2(
        item.resultadoFormacaoCarga
          ? item.resultadoFormacaoCarga.quantidadeEnviada
          : 0
      ),
      'carga-peso': toLocaleString2(
        item.resultadoFormacaoCarga
          ? item.resultadoFormacaoCarga.pesoEnviado
          : 0
      ),
      'vmm-primeira-entrada': item.previsaoDemanda?.primeiraEntradaDoProduto
        ? new Date(
            item.previsaoDemanda.primeiraEntradaDoProduto.split('T')[0] +
              'T12:00:00'
          ).toLocaleDateString('pt-BR')
        : '—',
      'vmm-janela-efetiva': item.previsaoDemanda?.janelaEfetivaDeDias
        ? `${item.previsaoDemanda.janelaEfetivaDeDias} dias`
        : '—',
      'ruptura-zero-dias':
        item.rupturaZeroDias != null
          ? item.rupturaZeroDias
            ? 'Sim'
            : 'Não'
          : '-',
      'ruptura-dez-dias':
        item.rupturaDezDias != null
          ? item.rupturaDezDias
            ? 'Sim'
            : 'Não'
          : '-',
      'calculo-saida-diaria':
        item.previsaoDemanda?.etapasCalculoSaidaMediaDiaria || [],
      'calculo-quantidade': item.etapasCalculoQuantidadeRecomendada || []
    })
  }

  return res
}
